import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ar from './locales/ar.json'
import en from './locales/en.json'
Vue.use(VueI18n)
const messages = {
	en: en,
	ar: ar
}
const defaultLang = localStorage.getItem('lang') || 'ar'
const i18n = new VueI18n({
	locale: defaultLang,
	fallbackLocale: 'en',
	messages
})

export default i18n
